import { Random } from "../util/Random";

export enum SoundType {
    SFX,
    MUSIC
}

export enum SoundByte {
    FireGun = "./audio/sfx/gun_fire.ogg",
    Explosion = "./audio/sfx/explosion.ogg",
    LaserBeam = "./audio/sfx/laserbeam.ogg",
    LaserCharge = "./audio/sfx/laser_charge.ogg",
    BulletHit = "./audio/sfx/bullet_hit.ogg",
    EnemyFireGun = "./audio/sfx/enemy_gun_fire.ogg",
    TextBlip = "./audio/sfx/text_blip.ogg",
    Break = "./audio/sfx/break.ogg",
    Exp1 = "./audio/sfx/exp1.ogg",
    Exp2 = "./audio/sfx/exp2.ogg",
    Exp3 = "./audio/sfx/exp3.ogg",
    Exp4 = "./audio/sfx/exp4.ogg",
    Exp5 = "./audio/sfx/exp5.ogg",

    BossMusic1 = "./audio/music/song1.ogg",
    WormSong = "./audio/music/worms.ogg",
    TitleSong = "./audio/music/title_music.ogg",
    BGM1 = "./audio/music/bgm1.ogg",
    BGM2 = "./audio/music/bgm2.ogg",
    BGM3 = "./audio/music/bgm3.ogg",
    WolfIntro = "./audio/music/wolf_intro.ogg",
    WolfBattle = "./audio/music/wolf_battle.ogg",
    Hive = "./audio/music/hive.ogg",
};

export function RandomExpSound() {
    const li = [
        SoundByte.Exp1,
        SoundByte.Exp2,
        SoundByte.Exp3,
        SoundByte.Exp4,
        SoundByte.Exp5,
    ];

    return li[Random.int(0, li.length)]
}